import { render, staticRenderFns } from "./OperativeTableSectionTitle.vue?vue&type=template&id=4ae19f99&"
import script from "./OperativeTableSectionTitle.vue?vue&type=script&lang=js&"
export * from "./OperativeTableSectionTitle.vue?vue&type=script&lang=js&"
import style0 from "./OperativeTableSectionTitle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports